/*!
 * vue-toastr v2.1.2 
 * (c) 2022 s4l1h
 * Released under the MIT License.
 */
import VueToastr from '../src/components/VueToastr.vue';

// export { default } from "./components/VueToastr.vue";

export default VueToastr;
